// import { createMuiTheme } from '@material-ui/core/styles';
import { createTheme } from '@mui/material/styles';
import { fontWeight } from '@mui/system';
import { css } from 'styled-components';

export const space = 0.25;
export const spaceUnit = 'em';
export const setSpace = (value) => (space * value) + spaceUnit;

export const respondTo = (breakpoint, content) => {
  return css`
  @media(max-width: ${Breakpoints[breakpoint]}){
    ${content};
  }
  `;
}

export const jsRespondTo = (breakpoint) => {
  const test = window.matchMedia(`(max-width: ${Breakpoints[breakpoint]})`);
  return (test.matches) ? true : false;
}

export const Breakpoints = {
  'mobile': '768px',
  'tablet': '1024px',
  'desktop': '1300px',
  'large': '1800px',
  'xlarge': '2200px',
  '2xlarge': '2600px'
}

const CaptureCollabStyles = {
  //
  // fonts: {
  //   lineHeight: "120%",
  //   heading: "le-monde-livre-std, serif",
  //   headingWeight: 100,
  //   headingLineHeight: "100%",
  //   body: "proxima-nova, sans-serif",
  //   bodyWeight: 400,
  //   bodyLineHeight: "100%",
  // },
  // JAKARTA
  // fonts: {
  //   lineHeight: "120%",
  //   heading: "Jakarta Sans, sans-serif",
  //   headingWeight: 700,
  //   headingLineHeight: "100%",
  //   body: "Jakarta Sans, sans-serif",
  //   bodyWeight: 400,
  //   bodyLineHeight: "100%",
  // },
  fonts: {
    lineHeight: "120%",
    heading: "'Poppins', sans-serif",
    headingWeight: 700,
    headingLineHeight: "100%",
    body: "'Poppins', sans-serif",
    bodyWeight: 400,
    bodyLineHeight: "100%",
  },
  // fonts: {
  //   lineHeight: "120%",
  //   heading: '"mundial", sans-serif',
  //   headingWeight: 700,
  //   headingLineHeight: "100%",
  //   body: '"mundial", sans-serif',
  //   bodyWeight: 300,
  //   bodyLineHeight: "100%",
  // },
}
const blue = '#0000ff';
const orange = '#fd3f17';

// const CaptureCollabTheme = {
//   colors: {
//     base: '#f7f6f3',
//     baseText: '#171919',
//     baseDark: 'rgba(0,0,0,0.5)',
//     primary: '#171919',
//     primaryText: '#f7f6f3',
//     secondary: '#171919',
//     secondaryText: '#f7f6f3',
//     dark: '#171919',
//     darkText: '#f7f6f3',
//     // baseAlternate: '#e8e6d6',
//     // Dark Mode
//     // baseAlternate: '#171919',
//     // baseAlternateText: '#f7f6f3',
//     // baseAlternateLight: '#393b3b',
//     baseAlternate: '#FFFFFF',
//     baseAlternateText: '#171919',
//     baseAlternateLight: '#f7f6f3',
//     error: '#FF5134',
//     warning: '#FFBADD',
//     success: '#BADDDD',
//     orangeRGB: '252,78,39',
//     iosBlue: '#006ee6',
//     blue: '#1500ff',
//     blueText: '#FFFFFF',
//     orange: '#fd3f17',
//     orangeText: '#FFFFFF'
//   },
//   radius: '6px',
//   radiusSmall: '3px',
//   radiusLarge: '12px',
//   shadow: {
//     none: '0px 0px 0px rgba(0,0,0,0)',
//     one: '0px 4px 8px -4px rgba(0,0,0,0)',
//     two: '0px 8px 16px -8px rgba(0,0,0,0)',
//     three: '0px 16px 32px -16px rgba(0,0,0,0.5)',
//     form: '0px 8px 16px -8px rgba(0,0,0,0.5)',
//   },
//   scale: {
//     none: 'scale3d(1,1,1)',
//     one: 'scale3d(1.025,1.025,1.025)',
//     down: 'scale3d(0.975,0.975,0.975)'
//   },
//   transition: {
//     one: 'all 250ms',
//     two: 'all 500ms',
//     three: 'all 1000ms'
//   },
//   lineHeight: "150%",
//   breakpoints: Breakpoints,
//   CaptureCollabStyles: CaptureCollabStyles
// }

const CaptureCollabTheme = {
  colors: {
    base: '#fafafa',
    baseText: '#1A1A1A',
    baseDark: 'rgba(0,0,0,0.5)',
    // primary: '#44EA9A',
    // primaryText: '#1A1A1A',
    primary: '#1A1A1A',
    primaryText: '#FFFFFF',
    secondary: '#8A84F7',
    secondaryText: '#1A1A1A',
    tertiary: '#f5deb3',
    tertiaryText: '#1A1A1A',
    dark: '#1A1A1A',
    darkText: '#FFFFFF',
    // baseAlternate: '#e8e6d6',
    // Dark Mode
    // baseAlternate: '#171919',
    // baseAlternateText: '#f7f6f3',
    // baseAlternateLight: '#393b3b',
    baseAlternate: '#FFFFFF',
    baseAlternateText: '#1A1A1A',
    baseAlternateLight: '#f7f6f3',
    error: '#FF5134',
    warning: '#FFBADD',
    success: '#BADDDD',
    orangeRGB: '252,78,39',
    iosBlue: '#006ee6',
    blue: '#1500ff',
    blueText: '#FFFFFF',
    orange: '#fd3f17',
    orangeText: '#FFFFFF',
    grey: '#dae1e7',
    greyText: '#1A1A1A',
    pop: '#44EA9A',
    popText: '#1A1A1A',
  },
  radius: '6px',
  radiusSmall: '3px',
  radiusLarge: '12px',
  borderWidth: '2px',
  shadow: {
    none: '0px 0px 0px currentColor',
    one: '0px 0px 0px 0px currentColor',
    two: '3px 3px 0px 0px currentColor',
    three: '6px 6px 0px 0px currentColor',
    form: '6px 6px 0px 0px currentColor',
    // box-shadow: 3px 3px 0px 0px ${Theme.colors.baseText};
    //         &:hover {
    //             box-shadow: 6px 6px 0px 0px ${Theme.colors.baseText};
    //         }
  },
  scale: {
    none: 'scale3d(1,1,1)',
    one: 'scale3d(1.025,1.025,1.025)',
    down: 'scale3d(0.975,0.975,0.975)'
  },
  transition: {
    one: 'all 250ms',
    two: 'all 500ms',
    three: 'all 1000ms'
  },
  lineHeight: "150%",
  breakpoints: Breakpoints,
  CaptureCollabStyles: CaptureCollabStyles
}

CaptureCollabTheme.elements = {
  input: {
    background: CaptureCollabTheme.colors.base,
    text: '#555555',
    inverse: CaptureCollabTheme.colors.baseAlternate,
    inverseText: CaptureCollabTheme.colors.baseAlternateText
  }
}



const LightMode = {
  colors: {
    base: '#F7F7F7',
    baseText: '#000',
    baseDark: '#E6E6E6',
    primary: '#6363D2',
    primaryText: '#FFF',
    secondary: '#C6E6FF',
    secondaryText: '#FFF',
    dark: '#0F1F2E',
    darkText: '#FFF',
    baseAlternate: '#FFF',
    baseAlternateText: '#000',
    error: '#FF5134',
    warning: '#FFBADD',
    success: '#BADDDD',

  },
  radius: '8px',
  radiusLarge: '24px',
  shadow: {
    none: '0px 0px 0px rgba(99,99,210,0)',
    one: '0px 2px 4px -1px rgba(99,99,210,0.3)',
    two: '0px 8px 16px -8px rgba(99,99,210,0.6)',
    three: '0px 16px 32px -16px rgba(99,99,210,0.6)',
  },
  scale: {
    none: 'scale3d(1,1,1)',
    one: 'scale3d(1.025,1.025,1.025)',
    down: 'scale3d(0.975,0.975,0.975)'
  },
  transition: {
    one: 'all 250ms',
    two: 'all 500ms',
    three: 'all 1000ms'
  },
  lineHeight: "150%",
  breakpoints: Breakpoints,
  CaptureCollabStyles: CaptureCollabStyles
}

LightMode.elements = {
  input: {
    background: LightMode.colors.base,
    text: '#555555',
    inverse: LightMode.colors.baseAlternate,
    inverseText: LightMode.colors.baseAlternateText
  }
}



const DarkMode = {
  colors: {
    base: '#000',
    baseText: '#FFF',
    primary: '#42e883',
    secondary: '#C6E6FF',
    dark: '#0F1F2E',
    baseAlternate: '#232323',
    error: '#FF5134',
    warning: '#FFBADD',
    success: '#BADDDD'
  },
  radius: '8px',
  radiusLarge: '24px',
  shadow: {
    none: 'inset 0px 0px 0px rgba(66,232,131,0)',
    one: 'inset 0px 0px 0px 0px rgba(66,232,131,0.3)',
    two: 'inset 0px 0px 0px 0px rgba(66,232,131,0.6)',
    three: 'inset 0px 0px 0px 0px rgba(66,232,131,0.6)',
  },
  scale: {
    none: 'scale3d(1,1,1)',
    one: 'scale3d(1.025,1.025,1.025)',
    down: 'scale3d(0.975,0.975,0.975)'
  },
  transition: {
    one: 'all 250ms',
    two: 'all 500ms',
    three: 'all 1000ms'
  },
  lineHeight: "150%",
  breakpoints: Breakpoints
}
DarkMode.elements = {
  input: {
    background: DarkMode.colors.base,
    text: '#CCC',
    inverse: DarkMode.colors.baseAlternate,
    inverseText: DarkMode.colors.baseAlternateText
  },
  button: {
    // disabled: {
    //   text: 'rgba(255,255,255,0.35)'
    // }
  }
}



// Set the Theme
export const Theme = CaptureCollabTheme;

export const MaterialTheme = createTheme({
  palette: {
    // mode: 'dark', // For Dark Mode
    primary: {
      // light: will be calculated from palette.primary.main,
      main: Theme.colors.primary,
      // contrastText: Theme.colors.base
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: Theme.colors.secondary,
    },
    base: {
      main: Theme.colors.base,
      contrastText: Theme.colors.baseText
    },
    baseAlternate: {
      main: Theme.colors.baseAlternate,
      contrastText: Theme.colors.baseAlternateText
    },
    blue: {
      main: Theme.colors.pop,
      contrastText: Theme.colors.popText
    },
    pop: {
      main: Theme.colors.pop,
      contrastText: Theme.colors.popText
    },
    typography: {
      fontFamily: CaptureCollabStyles.fonts.body,
      // body1: {
      //   fontFamily: CaptureCollabStyles.fonts.body,
      //   fontWeight: CaptureCollabStyles.fonts.bodyWeight
      // }
    }
  }
});